export const ADMIN_REDIRECT_PATH_KEY = "v1:adminRedirectPath";
export const HOTKEYS = {
  NEXT: "j",
  PREV: "k",
  APPROVE: "f",
  REJECT: "d",
  SWITCH_QUEUE: "t",
  ZEN: "z",
  BAN: "b",
  SEARCH: "ctrl+f",
  GUIDE: "shift+/",
};
export const MOD_QUEUE_SORT_ORDER = "v1:modQueueSortOrder";
